import { useCallback, useEffect } from 'react';

import { ENV_VARS } from 'app/config/environment-vars';

import { useRedirectWithLimit } from './useRedirectWithLimit';

/** Redirect to Identity Service to authenticate if not exceeding the limit. */
export function useReAuthenticate() {
  const [shouldRedirect, withLimit] = useRedirectWithLimit();

  const authUrl = ENV_VARS.IDENTITY_URL;

  const redirect = useCallback(() => {
    window.location.href = `${authUrl}/tenant?returnUrl=${window.location.origin}`;
  }, [authUrl]);

  useEffect(() => {
    withLimit(redirect);
  }, [redirect, withLimit]);

  return { shouldRedirect, redirect };
}
